import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useLayoutEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from '@/lib/constants/routes';
import {
  normalizeAppReturnPath,
  POST_LOGIN_REDIRECT_STORAGE_KEY,
} from '@/lib/auth/post-login-redirect';
import { hasInspectionPdfEligibleRole } from '@/lib/inspection-pdf-access';

export const InspectionReportDownloadRoute = () => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  useLayoutEffect(() => {
    if (isAuthenticated) {
      return;
    }
    const returnPath = `${location.pathname}${location.search}`;
    if (returnPath !== ROUTES.LOGIN) {
      sessionStorage.setItem(POST_LOGIN_REDIRECT_STORAGE_KEY, normalizeAppReturnPath(returnPath));
    }
  }, [isAuthenticated, location.pathname, location.search]);

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (!hasInspectionPdfEligibleRole(user?.roles)) {
    return <Navigate to={ROUTES.UNAUTHORIZED} replace />;
  }

  return <Outlet />;
};
